'use client';

const defaultProps = {
  emphasis: "high",
  variant: "body.base"
};
export {
  defaultProps
};
